import React from "react";

type ClipboardIconProps = React.SVGProps<SVGSVGElement> & { color?: string };

export const ClipboardIcon = ({ width = 24, height = 24, color = "#79808A", ...props }: ClipboardIconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="8" y="2" width="8" height="4" rx="1.5" stroke={color} strokeWidth="1.5"/>
    <path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M12 11h4M12 16h4" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="8" cy="11" r="1" fill={color}/>
    <circle cx="8" cy="16" r="1" fill={color}/>
  </svg>
);

export default ClipboardIcon;
